module.exports = __webpack_public_path__ + "static/media/gc-mixte-solo.aa7dc35b.png";